const selectElement = document.getElementById('claim-type-select') as HTMLSelectElement | null

if (selectElement) {
  selectElement.addEventListener('change', (event) => {
    const target = event.target as HTMLSelectElement
    const selectedValue = target.value
    if (selectedValue) {
      window.location.href = selectedValue
    }
  })
}
